import { render, staticRenderFns } from "./StockModal.vue?vue&type=template&id=4cd31362&"
import script from "./StockModal.vue?vue&type=script&lang=js&"
export * from "./StockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports